import reducer from './debts.reducer';
import * as selector from './debts.selector';
import * as constant from './debts.constant';
import subscriber from './debts.subscriber';
import saga from './debts.saga';

export default {
  reducer,
  constant,
  selector,
  subscriber,
  saga,
  name: constant.NAME,
};
